import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useMemo, useState } from 'react';
import MuiAlert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import { FloatingAlert } from './internal/FloatingAlert';
import { FullWidthAlert } from './internal/FullWidthAlert';
import { FULL_WIDTH_SIDE_PADDING } from './alert.consts';
import { ERROR600, ERROR700, ERROR800, GRAY600, GRAY700, PRIMARY600, PRIMARY700, PRIMARY800, SUCCESS600, SUCCESS700, SUCCESS800, WARNING600, WARNING700, WARNING800, WHITE } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
export function Alert(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? 'default' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'floating' : _props$size;
  var theme = useTheme();
  var severity = 'info';
  switch (color) {
    case 'error':
      severity = 'error';
      break;
    case 'warning':
      severity = 'warning';
      break;
    case 'success':
      severity = 'success';
      break;
  }
  var primaryButtonStyles = useMemo(function () {
    return getPrimaryButtonStyles(color, size);
  }, [color, size]);
  var secondaryButtonStyles = useMemo(function () {
    return getSecondaryButtonStyles(color, size);
  }, [color, size]);
  var _useState = useState("".concat(theme.spacing(4), " ").concat(FULL_WIDTH_SIDE_PADDING, "px")),
    _useState2 = _slicedToArray(_useState, 2),
    fullWidthPadding = _useState2[0],
    setFullWidthPadding = _useState2[1];
  var handleFullWidthPaddingChange = function handleFullWidthPaddingChange(isMobile) {
    if (isMobile) {
      setFullWidthPadding(theme.spacing(4));
    } else {
      setFullWidthPadding("".concat(theme.spacing(4), " ").concat(FULL_WIDTH_SIDE_PADDING, "px"));
    }
  };
  return size === 'floating' ? /*#__PURE__*/_jsx(MuiAlert, _extends({
    icon: false
  }, (color === 'default' || color === 'gray') && {
    color: color === 'default' ? 'info' : 'warning'
  }, {
    severity: severity,
    sx: {
      '.MuiAlert-icon': {
        padding: 0
      },
      '.MuiAlert-message': {
        padding: 0,
        width: '100%'
      },
      alignItems: 'start',
      maxWidth: '100%',
      padding: theme.spacing(4),
      position: 'relative'
    },
    variant: 'filled',
    children: /*#__PURE__*/_jsx(FloatingAlert, _extends({
      primaryButtonStyles: primaryButtonStyles,
      secondaryButtonStyles: secondaryButtonStyles
    }, props))
  })) : /*#__PURE__*/_jsx(MuiAlert, _extends({
    icon: false
  }, (color === 'default' || color === 'gray') && {
    color: color === 'default' ? 'info' : 'warning'
  }, {
    severity: severity,
    sx: {
      '.MuiAlert-icon': {
        padding: '6px'
      },
      '.MuiAlert-message': {
        padding: 0,
        width: '100%'
      },
      alignItems: 'center',
      padding: fullWidthPadding,
      position: 'relative'
    },
    variant: "outlined",
    children: /*#__PURE__*/_jsx(FullWidthAlert, _extends({
      handleFullWidthPaddingChange: handleFullWidthPaddingChange,
      primaryButtonStyles: primaryButtonStyles,
      secondaryButtonStyles: secondaryButtonStyles
    }, props))
  }));
}
var getPrimaryButtonStyles = function getPrimaryButtonStyles(color, size) {
  switch (color) {
    case 'default':
      if (size === 'floating') {
        return {
          '&:hover': {
            color: PRIMARY800
          },
          color: PRIMARY700
        };
      }
      return {
        color: WHITE
      };
    case 'gray':
      if (size === 'floating') {
        return {
          '&:hover': {
            color: PRIMARY800
          },
          color: PRIMARY700
        };
      }
      return {
        color: WHITE
      };
    case 'primary':
      {
        if (size === 'floating') {
          return {
            '&:hover': {
              color: PRIMARY800
            },
            color: PRIMARY700
          };
        }
        return {
          color: WHITE
        };
      }
    case 'error':
      return {
        '&:hover': {
          color: ERROR800
        },
        color: ERROR700
      };
    case 'warning':
      return {
        '&:hover': {
          color: WARNING800
        },
        color: WARNING700
      };
    case 'success':
      return {
        '&:hover': {
          color: SUCCESS800
        },
        color: SUCCESS700
      };
  }
};
var getSecondaryButtonStyles = function getSecondaryButtonStyles(color, size) {
  switch (color) {
    case 'default':
      if (size === 'floating') {
        return {
          '&:hover': {
            color: GRAY700
          },
          color: GRAY600
        };
      }
      return {
        color: GRAY700
      };
    case 'primary':
      if (size === 'floating') {
        return {
          '&:hover': {
            color: PRIMARY700
          },
          color: PRIMARY600
        };
      }
      return {
        color: GRAY700
      };
    case 'gray':
      {
        if (size === 'floating') {
          return {
            '&:hover': {
              color: GRAY700
            },
            color: GRAY600
          };
        }
        return {
          color: GRAY700
        };
      }
    case 'error':
      return {
        '&:hover': {
          color: ERROR700
        },
        color: ERROR600
      };
    case 'warning':
      return {
        '&:hover': {
          color: WARNING700
        },
        color: WARNING600
      };
    case 'success':
      return {
        '&:hover': {
          color: SUCCESS700
        },
        color: SUCCESS600
      };
  }
};